// Views/HeaderAndFooter.js
import React from "react";
import { Outlet, useNavigate } from "react-router-dom";
import FriendChallenges from "../components/FriendChallenges";

const HeaderAndFooter = ({ children }) => {
    const navigate = useNavigate();

    return (
        <div
            style={{
                display: "flex",
                flexDirection: "column",
                minHeight: "100vh",
            }}
        >
            {/* Header */}
            <header className="main-header">
                {/* Left side: "Chessmate" + the Nav Links */}
                <div className="header-left">
                    <h1 className="site-title" onClick={() => {
                        navigate("/");
                    }} style={{cursor: "pointer"}}>Chess Corner</h1>
                    <nav className="main-nav">
                        <a
                            onClick={() => {
                                navigate("/");
                            }}
                            className="nav-link"
                        >
                            Play
                        </a>
                        <a
                            onClick={() => {
                                navigate("/social");
                            }}
                            className="nav-link"
                        >
                            Social
                        </a>
                        <a
                            onClick={() => {
                                navigate("/leaderboards");
                            }}
                            className="nav-link"
                        >
                            Leaderboards
                        </a>
                    </nav>
                </div>

                {/* Right side: Logo + My Profile */}
                <div className="header-right">
                    <img
                        src="/logo.png"
                        alt="Site Logo"
                        className="header-logo"
                    />
                    <a
                        onClick={() => {
                            navigate("/my-profile");
                        }}
                        className="nav-link profile-link"
                    >
                        My Profile
                    </a>
                </div>
            </header>

            {/* Main (children) */}
            <div style={{ flex: 1 }}>
                <Outlet />
            </div>
            <footer style={{backgroundColor: "var(--primary-blue)", display: "flex", justifyContent: "space-between", alignItems: "center", height: "1.5rem", marginTop: "1rem", position: "relative"}}>
                <div style={{position: "fixed", bottom: "1rem", right: "2rem"}}>
                    <FriendChallenges/>
                </div>
                <p style={{fontSize: "0.7rem"}}>Chess Corner - If you'll have fun we'll have you</p>
                <p style={{fontSize: "0.7rem", cursor: "pointer"}} onClick={() => navigate("/credits")}>Credits</p>
            </footer>
        </div>
    );
};

export default HeaderAndFooter;
